import { descriptorsFactory } from '../../utils/filters';

export const manifestationTypeDescriptors = descriptorsFactory({
  name: 'manifestationType',
  clear: ['from_developer'],
})(
  {
    form: [{ key: 'from_developer', value: true, type: 'term' }],
    label: 'Застройщик',
    state: 'On',
  },
  {
    form: [{ key: 'from_developer', value: false, type: 'term' }],
    label: 'Агент или собственник',
    state: 'Off',
  },
  {
    form: [],
    label: 'Без фильтра',
    state: '',
  },
);
